module.exports = __webpack_public_path__ + "static/media/tauchsieder_fertig.ad250f8e.jpg";